import PropTypes from 'prop-types';
import { Depositos } from './Depositos';
import { Pagos } from './Pagos';

export const ControlPagos = (props) => {
  const { folioCredito, edit = true } = props;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 my-3">
      <Depositos folioCredito={folioCredito} edit={edit} />
      <Pagos folioCredito={folioCredito} />
    </div>
  );
};

ControlPagos.propTypes = {
  folioCredito: PropTypes.number,
  edit: PropTypes.bool
};
